module.exports = __webpack_public_path__ + "img/Groupred.2fb5b2b4.svg";